import React from "react";
import Image from "next/image";
import Breadcrumb from "@/Components/Breadcrumb/Breadcrumb";

interface BannerProps {
  block: any;
  breadcrumbs: any;
}
const Banner: React.FC<BannerProps> = ({ block, breadcrumbs }) => {
  return (
    <>
      <section className="request-proposal-banner bg-background-dark  py-[120px] lg:py-[150px] xl:pb-[240px]  relative z-0">
        <span className="absolute bottom-0 md:h-[36px] mb-[-1px] h-[36px] w-full bg-white z-10 block"></span>
        {/* Shapes */}
        <div className="banner-shape-1 absolute top-[0px] left-0 z-[1] w-[50%] md:w-[40%]">
          <Image
            src="/images/banner-left-layer-mobile.png"
            alt="Banner Shape"
            width={571}
            height={571}
            className="w-full h-full md:hidden"
          />
          <Image
            src="/images/banner-left-layer-tablet.png"
            alt="Banner Shape"
            width={571}
            height={571}
            className="w-full h-full hidden md:block lg:hidden"
          />
          <Image
            src="/images/banner-left-layer-desktop.png"
            alt="Banner Shape"
            width={571}
            height={571}
            className="w-full h-full hidden lg:block"
          />
        </div>
        <div className="banner-shape-1 absolute bottom-0 right-0 z-[-1] ">
          <Image
            src="/images/banner-right-layer-mobile.png"
            alt="Banner Shape"
            width={471}
            height={471}
            className="object-cover w-full h-full md:hidden"
          />
          <Image
            src="/images/banner-right-layer-tablet.png"
            alt="Banner Shape"
            width={471}
            height={471}
            className="object-cover w-full h-full hidden md:block lg:hidden"
          />
          <Image
            src="/images/banner-right-layer-desktop.png"
            alt="Banner Shape"
            width={471}
            height={471}
            className="object-cover w-full h-full hidden lg:block"
          />
        </div>
        <div className="container lg:p-[0px_24px]!">
          <div>
            {breadcrumbs?.item?.length > 0 && (
              <Breadcrumb
                items={breadcrumbs?.item ?? []}
                className="mb-[16px] lg:mb-[32px] xl:mb-[40px] flex justify-center"
              />
            )}
            <h1 className="text-white text-display font-extrabold text-center uppercase">
              {block.title}
            </h1>
            <p className="text-secondary-text-white font-regular text-center mt-4 text-subtitle-3">
              {block.description}
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Banner;
